import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-849413b8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "h100",
  style: {"background-color":"#353e54"}
}

import { reactive, onBeforeMount } from 'vue';
import { useRoute, onBeforeRouteUpdate, useRouter } from 'vue-router';
import { useRoutesList } from '@/store/router.store';
import { storeToRefs } from 'pinia';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute();
const dd = useRouter();
const stores = useRoutesList();
const { routesList } = storeToRefs(stores);

const state = reactive({
	defaultActive: route.meta.isDynamic ? route.meta.isDynamicPath : route.path,
	isCollapse: false,
	menuList: [] as any[],
});

/* 功能函数 */
const func = {
	setFilterRoutes: () => {
		state.menuList = func.filterRoutesFun(routesList.value);
	},

	/* 需要过滤隐藏的菜单 */
	filterRoutesFun: (arr: []) => {
		return arr
			.filter((item: any) => !item.meta?.hidden)
			.map((item: any) => {
				item = Object.assign({}, item);
				if (item.children) item.children = func.filterRoutesFun(item.children);
				return item;
			});
	},

	/* 设置高亮 */
	setHighLight: (currentRoute: any) => {
		const { path } = currentRoute;
		state.defaultActive = path;
	},
};

// 路由更新时·
onBeforeRouteUpdate((to) => {
	func.setHighLight(to);
});

onBeforeMount(() => {
	func.setHighLight(route);
	func.setFilterRoutes();
});

return (_ctx: any,_cache: any) => {
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_sub_menu = _resolveComponent("el-sub-menu")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_el_aside = _resolveComponent("el-aside")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_aside, { class: "layout-aside layout-aside-pc-220" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_scrollbar, {
          class: "flex-auto",
          ref: "layoutAsideScrollbarRef"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_menu, {
              class: "no-border",
              style: {"border-right":"0px"},
              router: "",
              "default-active": _unref(state).defaultActive,
              "unique-opened": true,
              collapse: _unref(state).isCollapse,
              "collapse-transition": false,
              "background-color": "#353e54",
              "active-text-color": "#ffd04b",
              "text-color": "#fff"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).menuList, (menu) => {
                  return (_openBlock(), _createElementBlock(_Fragment, null, [
                    ((menu.children ?? []).length > 0)
                      ? (_openBlock(), _createBlock(_component_el_sub_menu, {
                          index: menu.path,
                          key: menu.path
                        }, {
                          title: _withCtx(() => [
                            _createElementVNode("span", null, _toDisplayString(menu.meta.title ?? '未知菜单'), 1)
                          ]),
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menu.children, (child) => {
                              return (_openBlock(), _createBlock(_component_el_menu_item, {
                                index: child.path
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(child.meta.title ?? '未知菜单'), 1)
                                ]),
                                _: 2
                              }, 1032, ["index"]))
                            }), 256))
                          ]),
                          _: 2
                        }, 1032, ["index"]))
                      : (_openBlock(), _createBlock(_component_el_menu_item, {
                          index: menu.path,
                          key: menu.path
                        }, {
                          title: _withCtx(() => [
                            _createElementVNode("span", null, _toDisplayString(menu.meta.title ?? '未知菜单'), 1)
                          ]),
                          _: 2
                        }, 1032, ["index"]))
                  ], 64))
                }), 256))
              ]),
              _: 1
            }, 8, ["default-active", "collapse"])
          ]),
          _: 1
        }, 512)
      ]),
      _: 1
    })
  ]))
}
}

})